// @ts-strict-ignore
import { ArticleVO } from '@article/model/vo/article.vo';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { Connection } from '@3d-scene/model3d/connection';
import { BaseConnectionOperation } from './base-connection-operation';
import { IOperation } from '@shared/undo/operation/i-operation';
import { ConnectionDefinition } from '@article/components/connections/connection-creation/connection-configuration';
import { SceneManager } from '@3d-scene/manager/scene.manager';
import { ConnectionConverter } from '@article/components/connections/connection-creation/connection-converter';
import { ConnectionCreator } from '@article/components/connections/connection-creation/connection-creator';
import { ProjectArticleManager } from '@project/components/article/manager/project-article.manager';
import { SelectionModel } from '@project/components/article/model/selection.model';
import { ProjectModel } from '@project/model/project.model';
import { AdminService } from '../services/admin.service';
import { SelectionModelService } from '@project/components/article/service/selection-model.service';
import { ApplicationRefreshService } from '@services/application-refresh.service';

export class ChangeConnectionSubTypeOperation extends BaseConnectionOperation implements IOperation {
  constructor(
    connection: Connection,
    articleContainer: ArticleContainer,
    article: ArticleVO,
    private _oldConnectionDefinition: ConnectionDefinition,
    private _newConnectionDefinition: ConnectionDefinition,
    adminService: AdminService,
    projectModel: ProjectModel,
    selectionModel: SelectionModel,
    selectionModelService: SelectionModelService,
    sceneManager: SceneManager,
    projectArticleManager: ProjectArticleManager,
    connectionCreator: ConnectionCreator,
    connectionConverter: ConnectionConverter,
    applicationRefreshService: ApplicationRefreshService,
    connections?: Connection[]
  ) {
    super(
      adminService,
      projectModel,
      selectionModel,
      selectionModelService,
      sceneManager,
      projectArticleManager,
      connectionCreator,
      connectionConverter,
      connection,
      articleContainer,
      article,
      applicationRefreshService,
      connections
    );
  }

  public getQualifiedClassName(): string {
    return 'ChangeConnectionSubTypeOperation';
  }

  public getOperationDescription(): string {
    return 'changeConnectionSubTypeOperation.description';
  }

  public async performRedo(): Promise<void> {
    this.changeConnectionSubType(this._newConnectionDefinition);
  }

  public async performUndo(): Promise<void> {
    this.changeConnectionSubType(this._oldConnectionDefinition);
  }
}
